import BankSlipPayment from './BankSlipPayment.vue';

export default BankSlipPayment;

